// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_fu-6";
export var emphasizeQuantity = "_fu-3";
export var flatBottomCorners = "_fu-5";
export var productImage = "_fu-0";
export var quantityContainer = "_fu-2";
export var tooltip = "_fu-1";
export var wrapAndEllipsesOverflow = "_fu-4";